export default function ConsultationSection() {
  const steps = [
    {
      step: "Step 01",
      title: "まずお話を聞かせてください",
      desc: "普段どんな靴でお悩みか、どんな靴が好きか。まずここから始めます。",
    },
    {
      step: "Step 02",
      title: "足を丁寧に計測します",
      desc: "長さ・幅・甲の高さ・アーチ。足の特徴を数値と感覚の両方で確認します。",
    },
    {
      step: "Step 03",
      title: "あなたに合う靴をご提案",
      desc: "足タイプと好みを合わせて、試し履きしながら一緒に選びます。",
    },
    {
      step: "Step 04",
      title: "歩いて確認・微調整",
      desc: "「あ、これです」という感覚まで、歩き心地を確認して仕上げます。",
    },
  ];

  return (
    <section id="consultation" className="bg-white py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image side */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden w-full h-[480px] md:h-[560px]">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20friendly%20Japanese%20female%20shoe%20store%20staff%20with%20gentle%20smile%20helping%20young%20woman%20customer%20try%20on%20elegant%20nude%20pumps%2C%20intimate%20consultation%20in%20beautiful%20shoe%20boutique%2C%20soft%20warm%20interior%20lighting%2C%20cream%20white%20interior%2C%20natural%20conversation%20and%20trust%2C%20lifestyle%20photography%2C%20not%20medical%2C%20fashionable&width=700&height=900&seq=consult1&orientation=portrait"
                alt="接客・診断体験"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Float card */}
            <div className="absolute -bottom-4 -right-4 md:bottom-6 md:right-6 bg-white rounded-2xl shadow-none border border-[#F0EBE3] p-5 max-w-[200px]">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 flex items-center justify-center bg-[#F5F0EA] rounded-full">
                  <i className="ri-time-line text-[#B8895A] text-sm" />
                </div>
                <span className="text-[#1C1917] text-xs font-bold" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  所要時間
                </span>
              </div>
              <p className="text-[#1C1917] text-xl font-bold" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                60〜90分
              </p>
              <p className="text-[#78716C] text-xs mt-1" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                初回フィッティング
              </p>
            </div>
          </div>

          {/* Text side */}
          <div>
            <p
              className="text-[#B8895A] text-xs tracking-widest mb-4 uppercase"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              Fitting Experience
            </p>
            <h2
              className="text-3xl md:text-4xl font-bold text-[#1C1917] leading-snug mb-6"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              「靴を売る」より、
              <br />
              「まず知る」から。
            </h2>
            <p
              className="text-[#78716C] text-sm leading-loose mb-10"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              初めての方も、ふらっと来ていただければ大丈夫。
              難しい専門用語は一切使いません。
              <br />
              あなたのペースで、丁寧に進めます。
            </p>

            {/* Steps */}
            <div className="space-y-6">
              {steps.map((s, i) => (
                <div key={i} className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#F5F0EA] rounded-full">
                    <span className="text-[#B8895A] text-xs font-bold" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                      {i + 1}
                    </span>
                  </div>
                  <div>
                    <p className="text-[#B8895A] text-[10px] tracking-widest mb-1" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                      {s.step}
                    </p>
                    <h3
                      className="text-[#1C1917] text-sm font-bold mb-1"
                      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                    >
                      {s.title}
                    </h3>
                    <p className="text-[#78716C] text-xs leading-loose" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                      {s.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href="#reservation"
                className="flex items-center gap-2 bg-[#1C1917] text-white px-6 py-3.5 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-[#44403C] transition-colors cursor-pointer"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                <i className="ri-calendar-check-line" />
                来店予約をする
              </a>
              <a
                href="#line"
                className="flex items-center gap-2 border border-[#1C1917] text-[#1C1917] px-6 py-3.5 rounded-full text-sm font-medium whitespace-nowrap hover:bg-[#F5F0EA] transition-colors cursor-pointer"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                <i className="ri-question-line" />
                まず相談してみる
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}